'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _get2 = require('babel-runtime/helpers/get');
var _get3 = _interopRequireDefault(_get2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _each2 = require('lodash/each');
var _each3 = _interopRequireDefault(_each2);
var _class;
var _d = require('d3');
var _d2 = _interopRequireDefault(_d);
var _axis = require('../axis/');
var _axis2 = _interopRequireDefault(_axis);
var _utils = require('../utils/');
var utils = _interopRequireWildcard(_utils);
var _selectors = require('./selectors');
var _selectors2 = _interopRequireDefault(_selectors);
var _accessors = require('./accessors');
var _accessors2 = _interopRequireDefault(_accessors);
var _eauors = require('./eauors');
var _eauors2 = _interopRequireDefault(_eauors);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var GridChart = (0, _selectors2.default)(_class = (0, _accessors2.default)(_class = (0, _eauors2.default)(_class = function (_AxisChart) {
  (0, _inherits3.default)(GridChart, _AxisChart);
  function GridChart(el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var getInitialOptions = arguments[3];
    (0, _classCallCheck3.default)(this, GridChart);
    var _this = (0, _possibleConstructorReturn3.default)(this, (GridChart.__proto__ || (0, _getPrototypeOf2.default)(GridChart)).call(this, el, options, data, getInitialOptions));
    _contructor(el, _this.options, data, {
      selectors: _this.constructor.selectors,
      accessors: _this.constructor.accessors,
      eauors: _this.constructor.eauors
    }, _this.base, _this.axis);
    return _this;
  }
  (0, _createClass3.default)(GridChart, [{
    key: 'update',
    value: function update(el) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var getInitialOptions = arguments[3];
      (0, _get3.default)(GridChart.prototype.__proto__ || (0, _getPrototypeOf2.default)(GridChart.prototype), 'update', this).call(this, el, options, data, getInitialOptions);
      _update(el, this.options, data, {
        selectors: this.constructor.selectors,
        accessors: this.constructor.accessors,
        eauors: this.constructor.eauors
      }, this.base, this.axis);
    }
  }]);
  return GridChart;
}(_axis2.default)) || _class) || _class) || _class;
exports.default = GridChart;
function _contructor(el, options, data, ors, base, axis) {
  //console.info(utils.prefix, '\t\t', 'GridChart', '_contructor', '>>');

  utils.noElError(el);
  _d2.default.select(el).select(utils.selector(ors.selectors.base)).call(utils.setupElement, 'svg:g', ors.selectors.xGrid).call(utils.setupElement, 'svg:g', ors.selectors.yGrid);
  _update(el, options, data, ors, base, axis);

  //console.info(utils.prefix, '\t\t', 'GridChart', '_contructor', '<<');
}
function _update(el, options, data, ors, base, axis) {
  //console.info(utils.prefix, '\t\t', 'GridChart', '_update', '>>');

  utils.noElError(el);
  if (utils.noDataError(ors.accessors.data(data), '\t\t', 'GridChart')) {
    _d2.default.select(el).select(utils.selector(ors.selectors.base)).selectAll(utils.selector(ors.selectors.xLine)).remove();
    _d2.default.select(el).select(utils.selector(ors.selectors.base)).selectAll(utils.selector(ors.selectors.yLine)).remove();
    return;
  }
  (0, _each3.default)(['x', 'y'], function (prefix) {
    var gridSelector = ors.selectors[prefix + 'Grid'];
    var lineSelector = ors.selectors[prefix + 'Line'];
    var lineOptions = options.grid[prefix];
    var lineData = ors.accessors[prefix + 'Ticks'](base, axis, options.axis.x);
    var lineScale = ors.accessors[prefix + 'Scale'](base, axis);
    var lineRange = ors.accessors[prefix + 'Range'](base, axis);
    var lineEnter = ors.eauors[prefix + 'LineEnter'];
    var lineUpdate = ors.eauors[prefix + 'LineUpdate'];
    var lineJoin = _d2.default.select(el).select(utils.selector(ors.selectors.base)).select(utils.selector(gridSelector)).selectAll(utils.selector(lineSelector)).data(lineData);
    lineJoin.enter().call(lineEnter, lineOptions, lineSelector);
    lineJoin.call(lineUpdate, lineOptions, options, lineScale, lineRange);
    lineJoin.exit().remove();
  });

  //console.info(utils.prefix, '\t\t', 'GridChart', '_update', '<<');
}